import { action, computed, observable } from 'mobx';

import { LoyaltyApiSdk } from '~api/LoyaltyApiSdk';
import LoyaltyInfo, { ILoyaltyApiResponse } from '~domain/entities/LoyaltyInfo';

import { AuthenticatedRepository } from './AuthenticatedRepository';

export class LoyaltyRepository extends AuthenticatedRepository {
    private apiSdk: LoyaltyApiSdk;
    @observable private loyaltyData: LoyaltyInfo;

    constructor(loyaltyApiSdk: LoyaltyApiSdk) {
        super();
        this.apiSdk = loyaltyApiSdk;
    }

    @action public fetchLoyaltyInfo = async () => {
        return super.ensureData();
    };

    @action public fetchData = async (userId: string) => {
        const data: ILoyaltyApiResponse = await this.apiSdk.getLoyaltyByUserId(userId);
        const loyaltyData = LoyaltyInfo.fromJSON(data);
        this.setLoyaltyData(loyaltyData);
    };

    @action public setLoyaltyData = (loyaltyData: LoyaltyInfo) => {
        this.loyaltyData = loyaltyData;
    };

    @computed
    public get loyaltyInfo() {
        return this.loyaltyData;
    }
}
